import React, { useEffect } from "react";
import confetti from "canvas-confetti";

import styles from "./SuccessPage.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";

const SuccessPage = () => {
  const navigate = useNavigate();
  const { fetchUserData } = useUser();
  useEffect(() => {
    confetti({
      particleCount: 500,
      spread: 500,
      origin: { y: 0.5 },
      colors: ["#ff0000", "#00ff00", "#ffffff"],
    });
  }, []);

  const handleClick = async (e) => {
    e.preventDefault(); // Prevent default <a> behavior

    try {
      await fetchUserData(); // Wait for fresh user data
      navigate("/"); // Then go home
    } catch (err) {
      console.error("Failed to fetch user data before redirecting:", err);
    }
  };

  return (
    <div className={styles.container}>
      <img src="/target.png" alt="Target with darts" className={styles.image} />
      <h3 className={styles.title}>Congratulations!</h3>
      <p className={styles.subtitle}>
        You’ve secured your spot in the next challenge
      </p>
      <a href="#" onClick={handleClick} className={styles.link}>
        Back to home
      </a>
    </div>
  );
};

export default SuccessPage;
